const state = {
  showLines: false,
};

const getters = {
  showLines: state => state.showLines,
};

const actions = {
  setLines({ commit }, option) {
    commit('setShowLines', option);
  },
};

const mutations = {
  setShowLines: (state, option) => {
    state.showLines = option;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
